import React from 'react';
import { useTournament } from '../hooks/useTournament';

const ScoringSettings = () => {
  const { scoringConfig, updateScoringConfig } = useTournament();

  const handleIncrement = (field, min = null, max = null) => {
    const current = scoringConfig[field];
    if (max === null || current < max) {
      updateScoringConfig({ [field]: current + 1 });
    }
  };

  const handleDecrement = (field, min = null, max = null) => {
    const current = scoringConfig[field];
    if (min === null || current > min) {
      updateScoringConfig({ [field]: current - 1 });
    }
  };

  return (
    <div className="section scoring-settings">
      <div className="section-header">
        <h2>Punktevergabe</h2>
      </div>
      <div className="scoring-grid">
        <div className="scoring-row">
          <label className="scoring-label">
            <span className="scoring-icon">🏆</span>
            <span>Sieg:</span>
          </label>
          <div className="number-input-control">
            <button
              className="number-control-button"
              onClick={() => handleDecrement('winPoints', 0)}
              disabled={scoringConfig.winPoints <= 0}
            >−</button>
            <span className="number-display">{scoringConfig.winPoints}</span>
            <button
              className="number-control-button"
              onClick={() => handleIncrement('winPoints')}
            >+</button>
          </div>
        </div>
        <div className="scoring-row">
          <label className="scoring-label">
            <span className="scoring-icon">🤝</span>
            <span>Unentschieden:</span>
          </label>
          <div className="number-input-control">
            <button
              className="number-control-button"
              onClick={() => handleDecrement('drawPoints', 0)}
              disabled={scoringConfig.drawPoints <= 0}
            >−</button>
            <span className="number-display">{scoringConfig.drawPoints}</span>
            <button
              className="number-control-button"
              onClick={() => handleIncrement('drawPoints')}
            >+</button>
          </div>
        </div>
        <div className="scoring-row">
          <label className="scoring-label">
            <span className="scoring-icon">⚽</span>
            <span>Geschossenes Tor:</span>
          </label>
          <div className="number-input-control">
            <button
              className="number-control-button"
              onClick={() => handleDecrement('goalScoredPoints', 0)}
              disabled={scoringConfig.goalScoredPoints <= 0}
            >−</button>
            <span className="number-display">{scoringConfig.goalScoredPoints}</span>
            <button
              className="number-control-button"
              onClick={() => handleIncrement('goalScoredPoints')}
            >+</button>
          </div>
        </div>
        <div className="scoring-row">
          <label className="scoring-label">
            <span className="scoring-icon">🥅</span>
            <span>Kassiertes Tor:</span>
          </label>
          <div className="number-input-control">
            <button
              className="number-control-button"
              onClick={() => handleDecrement('goalConcededPoints')}
            >−</button>
            <span className="number-display">{scoringConfig.goalConcededPoints}</span>
            <button
              className="number-control-button"
              onClick={() => handleIncrement('goalConcededPoints', null, 0)}
              disabled={scoringConfig.goalConcededPoints >= 0}
            >+</button>
          </div>
        </div>
      </div>
      <div className="info-text">
        <strong>Punkteberechnung</strong>
        <ul>
          <li>
            <strong>Gesamtpunkte:</strong> Torpunkte + Bonuspunkte
          </li>
          <li>
            <strong>Torpunkte:</strong> (Geschossene Tore × Torwert) - (Kassierte Tore × Gegentorwert)
          </li>
          <li>
            <strong>Bonuspunkte:</strong> Sieg- und Unentschieden-Punkte pro Spiel
          </li>
        </ul>
        <div>
          <strong>Beispiele (Wertung: Tore 1 Punkt, Sieg 5 Punkte, Gegentore -1 Punkt)</strong>
          <ul>
            <li>
              Ergebnis 3:1, Sieg → Torpunkte: 3×1 - 1×1 = 2, Bonus: 5 → Gesamt: 7 für den Sieger
            </li>
            <li>
              Ergebnis 3:1, Niederlage → Torpunkte: 1×1 - 1×3 = -2, Bonus: 0 → Gesamt: -2 für den Verlierer
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ScoringSettings;
